(function () {

  const canvas = document.getElementById("sig-canvas");
  if (!canvas) return;

  const ctx = canvas.getContext("2d");
  ctx.strokeStyle = "#222";
  ctx.lineWidth = 2;

  let drawing = false;
  let hasSignature = false;

  function getPos(e) {
    const rect = canvas.getBoundingClientRect();
    const touch = e.touches ? e.touches[0] : e;
    return {
      x: touch.clientX - rect.left,
      y: touch.clientY - rect.top
    };
  }

  function start(e) {
    drawing = true;
    const pos = getPos(e);
    ctx.beginPath();
    ctx.moveTo(pos.x, pos.y);
    e.preventDefault();
  }

  function draw(e) {
    if (!drawing) return;
    const pos = getPos(e);
    ctx.lineTo(pos.x, pos.y);
    ctx.stroke();
    hasSignature = true;
    e.preventDefault();
  }

  function stop() {
    drawing = false;
  }

  canvas.addEventListener("mousedown", start);
  canvas.addEventListener("mousemove", draw);
  canvas.addEventListener("mouseup", stop);

  canvas.addEventListener("touchstart", start);
  canvas.addEventListener("touchmove", draw);
  canvas.addEventListener("touchend", stop);

  document.getElementById("sig-clearBtn").addEventListener("click", function () {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    hasSignature = false;
    document.getElementById("signatureData").value = "";
    document.getElementById("signatureError").style.display = "none";
  });

  const form = canvas.closest("form");

  form.addEventListener("submit", function (e) {
    if (!hasSignature) {
      e.preventDefault();
      document.getElementById("signatureError").style.display = "block";
      canvas.scrollIntoView({ behavior: "smooth", block: "center" });
      return;
    }
    // document.getElementById("signatureData").value = canvas.toDataURL("image/png");

    // document.getElementById("signatureData").value = data;

    const data = canvas.toDataURL("image/png");
    document.getElementById("signatureData").value = data;


    // send signature AFTER submit
    setTimeout(() => {
     fetch("/apps/signature-handler?source=register", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: document.getElementById("RegisterForm-email").value,
          signature: data
        })
      });
    }, 1000);

  });

})();
